import { createAction, createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import API, { typeThrownException } from '@acorn-portal/shared/src/services/AxiosInstance';
import { VehicleClient, VehicleLookupResponse } from '@acorn-portal/shared/src/services/lookupApi';

export const GlobalResetRedux = createAction('GLOBAL_RESET');

const INITIAL_STATE: VehicleLookupResponse = {
	vehicleInfo: {},
};

export const getVehicleDetailsByVrm = createAsyncThunk(
	'vehicleLookupSlice/getVehicleDetailsByVrm',
	async (vrm: string, thunkApi) => {
		try {
			const service = new VehicleClient(undefined, API);
			const response = await service.getVehicleDetailsByVrm(vrm);
			return response;
		} catch (e) {
			if (axios.isAxiosError(e) && e.response) {
				if (e.response.status < 200 || e.response.status > 300) {
					return thunkApi.rejectWithValue(e);
				}
			}
			if (typeThrownException(e) && e.status) {
				if (e.status < 200 || e.status > 300) {
					return thunkApi.rejectWithValue(e);
				}
			}

			throw e;
		}
	},
);

export const vehicleLookupSlice = createSlice({
	name: 'vehicleLookupSlice',
	initialState: INITIAL_STATE,
	reducers: {
		updateResult: (state, action: PayloadAction<Partial<VehicleLookupResponse>>) => ({
			...state,
			...action.payload,
		}),
	},
	extraReducers: (builder) => {
		builder.addCase(GlobalResetRedux, () => {
			return INITIAL_STATE;
		});
		builder.addCase(getVehicleDetailsByVrm.pending, () => {
			// Set a loading state if needed
		});
		builder.addCase(getVehicleDetailsByVrm.fulfilled, (state, { payload }) => {
			return {
				...state,
				...payload,
				vehicleInfo: {
					...state.vehicleInfo,
					...payload.vehicleInfo,
					grossWeight: payload.vehicleInfo.grossWeight ?? '0',
				},
			};
		});
		builder.addCase(getVehicleDetailsByVrm.rejected, (state) => {
			console.error('failed to fetch vehicle');
			return { ...state };
		});
	},
});

export const { updateResult } = vehicleLookupSlice.actions;
export default vehicleLookupSlice.reducer;
